// Standard variable for different collection;
var base_sqft = {
  'coretec-stratum-500': 26.68,
  'coretec-stratum-700': 38.24,
  'coretec-stratum-xl': 26.95,
  'coretec-stratum-1200-tile': 32.04,
  'coretec-stratum-1800-tile': 30.86,
  'coretec-stratum-vortex': 31.73,
  'coretec-stratum-eiris': 17.43,
  'coretec-stratum-linear': 23.95,
  'coretec-stratum-defined': 23.64,
  'geowood-oak': 23.31,
  'geowood-maple': 23.31,
  'geowood-bamboo': 24.60,
  'vinyl-long-board': 26.62,
  'vinyl-mute-step': 24.03,
  'vinyl-classic': 23.77,
  'vinyl-plus': 23.76,
  'engineered-bamboo': 21.50,
  

}
var total_box;
var end_sqft;


coverageCalculation = (evt, collection_title) => {
  var $this = $(evt);
  var title =  (collection_title.toString()).toLowerCase();
  var val = parseFloat($this.val());
  var check = (val != 'underfined');

  if(isNaN(val)){
    return;
  }
  if(check){
    var integerPart = Math.floor(val/base_sqft[title]);
    var ans = val/base_sqft[title] ;

    if(ans > integerPart){
      $('#Quantity').val(integerPart+1);
      total_box = integerPart + 1;
      var total_sqft = ((integerPart+1) * base_sqft[title]).toFixed(2);
      end_sqft = total_sqft
      $('#sqft-field').text(total_sqft);
    }
    else{
      $('#Quantity').val(integerPart);
      total_box = integerPart;
      var total_sqft = ((integerPart) * base_sqft[title]).toFixed(2);
      end_sqft = total_sqft
      $('#sqft-field').text(total_sqft);
    }

  }
};

showPrice = (evt, price) => {
  var final = parseFloat(price) * total_box;
  final = final.toFixed(2);
  if(isNaN(final)){
    // Price field, sqft field and box field
    $('#price-field').text('$0');
    $('#box-field').text('0');
    $('#sqft-field').text('0 sqft');
    $('#cartjsBtn').prop('disabled', true);
  }
  else {
    // Price field and box field
    $('#price-field').text('$'+final);
    $('#box-field').text(total_box);

    $('#cartjsBtn').prop('disabled', false);
    $('#user-note').val('Total Sqft: ' + end_sqft + ".  Total Boxes Needed:  "+ total_box + " Final Price: $"+ final + " USD " );
  }
}

cartjsRemove = (evt, variantID) => {
  CartJS.updateItemById(variantID, 0, {}, {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
      $('#AddToCart-product-template').click();
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", textStatus);
    }
  });
}

// From jsfiddle: http://jsfiddle.net/S9G8C/203/
function validateFloatKeyPress(el, evt) {
    var charCode = (evt.which) ? evt.which : event.keyCode;
    var number = el.value.split('.');
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    //just one dot
    if(number.length>1 && charCode == 46){
         return false;
    }
    //get the carat position
    var caratPos = getSelectionStart(el);
    var dotPos = el.value.indexOf(".");
    if( caratPos > dotPos && dotPos>-1 && (number[1].length > 1)){
        return false;
    }
    return true;
}

//thanks: http://javascript.nwbox.com/cursor_position/
function getSelectionStart(o) {
	if (o.createTextRange) {
		var r = document.selection.createRange().duplicate()
		r.moveEnd('character', o.value.length)
		if (r.text == '') return o.value.length
		return o.value.lastIndexOf(r.text)
	} else return o.selectionStart
}
